import {i18n} from '@yourcoach/i18n';

import type {MembershipApiModel} from '../../../../api/membership';
import type {GetComponentProps} from '../../../../utils/utility-types';
import type {CourseListItemJSX} from '../../components/CourseListItem';
import type {GetButtonsConfig} from './types';

import {membershipStore} from '../../../../api/membership';
import {inviteDelete} from '../../../../services/entity-action/invite/invite.delete';
import {isCourseAvailableToJoin} from '../../../../utils/entity/course/isCourseAvailableToJoin';
import {logger} from '../../../../utils/logger';

export function getButtons({
  course,
  isAutoAccept,
  onJoinClick,
}: GetButtonsConfig): GetComponentProps<typeof CourseListItemJSX>['buttons'] {
  const membership = membershipStore.membershipLookup.get(course._id);

  if (membership?.status === 'proposed') {
    return [
      {
        onClick: () => {
          logger.event('invite_decline_tap', {
            place: 'group_view',
            program_type: 'group',
          });
          inviteDelete({invite: membership as MembershipApiModel});
        },
        scheme: 'danger',
        text: i18n.t('shared:decline'),
      },
      {
        onClick: () => {
          logger.event('invite_accept_tap', {
            place: 'group_view',
            program_type: 'group',
          });
          onJoinClick(course);
        },
        scheme: 'secondary',
        text: i18n.t('shared:accept_and_join'),
      },
    ];
  } else if (
    membership?.status === 'active' ||
    membership?.status === 'accepted'
  ) {
    return [
      {
        disabled: true,
        scheme: 'secondary-light',
        text: i18n.t('shared:joined'),
      },
    ];
  } else if (membership?.status === 'requested') {
    return [
      {
        disabled: true,
        scheme: 'secondary-light',
        text: i18n.t('shared:request_sent'),
      },
    ];
  } else if (isCourseAvailableToJoin(course)) {
    return [
      {
        onClick: () => {
          if (!isAutoAccept) {
            logger.event('request_join_tap', {
              program_type: 'group',
            });
          }

          onJoinClick(course);
        },
        scheme: 'secondary',
        text: isAutoAccept
          ? i18n.t('shared:join_now')
          : i18n.t('shared:request_to_join'),
      },
    ];
  }

  return [];
}
